import { Container } from 'react-bootstrap';
import { css } from '@emotion/css';
import { Link } from 'react-router-dom';

interface HeaderProps {
    isHeader?:boolean;
    handleScroll?:Function;
}

const Header = (props: HeaderProps) => {
    return (
        <div
            className={css`
                position: sticky;
                width: 100vw;
                top: 0;
                z-index: 999;
                background-color: #02317C; 
            `}
        >
            <Container>
                <div
                    className={css`
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        
                        a {
                            text-decoration: none;
                        }
                        span {
                            margin-left: 4px;
                            font-size: 12px;
                            color: #999;
                        }
                    `}
                >
                    <Link to="/" style={{margin: '20px 0'}}>
                        <img src="/images/logo.png" height="60" alt="Logo" />
                    </Link>
                </div>
            </Container>
        </div>
    );
};

export default Header;
